import { useLayoutEffect } from 'react'
import { Outlet, useLocation } from 'react-router'
import { createTheme, CssBaseline, ThemeProvider } from '@mui/material'

import { generateTheme } from '../../providers/mui-theme-provider'
import ErrorBoundary from '../error-boundary'

interface IProps {
  useDarkBackground?: boolean
}

const RouteWrapper = (props: IProps) => {
  const { useDarkBackground = false } = props
  const lightTheme = createTheme(generateTheme('light'))
  const darkTheme = createTheme(generateTheme('dark'))
  const location = useLocation()

  useLayoutEffect(() => {
    // Scroll to the top of the page when the route changes
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' })
  }, [location.pathname])

  return (
    <ErrorBoundary>
      <ThemeProvider theme={useDarkBackground ? darkTheme : lightTheme}>
        <CssBaseline />
        <Outlet />
      </ThemeProvider>
    </ErrorBoundary>
  )
}

export default RouteWrapper
